import React from 'react';
import CustomPrimaryButton from '../../shared/components/CustomPrimaryButton';
import RedirectInfo from '../../shared/components/RedirectInfo';
import { useNavigate } from 'react-router-dom';
import { Tooltip } from '@mui/material';



const LoginPageFooter = ({ handleLogin, isFormValid }) => {
    const navigate=useNavigate();
    const handlePushToRegistration=()=>{
   navigate("/registration")

    }
    const getFormNotValidMessage=()=>{
        return "Введите корректный e-mail и пароль от 5 до 11 символов"
    
    }
    const getFormValidMessage=()=>{
        return "Нажмите, чтобы войти";
    }
	return (
        <>
        <Tooltip title={!isFormValid ? getFormNotValidMessage() : getFormValidMessage()}>
		<div>
			<CustomPrimaryButton
				label='Войти'
				additionalStyles={{ marginTop: '30px' }}
				disabled={!isFormValid}
				onClick={handleLogin}
			/>
		</div>
        </Tooltip>
        <RedirectInfo text="Нет аккаунта? " redirectText="Создать аккаунт" additionalStyles={{marginTop:"5px"}} redirectHandler={handlePushToRegistration} />
        </>
	);
};

export default LoginPageFooter;
